angular.module("ainapp")
    .controller("multiPurchaseEnquiryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.VoucherName = "Purchase Enquiry";
            $scope.PageName = "Multi Purchase Enquiry";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.getExtramasters();

            $scope.TableDesign = {};
            MainService.TableDesignsbyVoucher("Purchase Enquiry").then(function (response) {
                $scope.TableDesign = response.data;
            });

            $scope.AvailableSuppliers = [];
            MainService.GetAvailableSuppliersForProducts().then(function (response) {
                $scope.AvailableSuppliers = response.data;
            });


            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.getPurchaseRequestbyId(data).then(function (response) {
                    if (response.data) {
                        MainService.GetNextPurchaseEnquiryNo().then(function (response2) {
                            $scope.VoucherNumber = response2.data;
                            response.data[0].Id = "";
                            response.data[0].CustomerId = "";
                            response.data[0].Customer = {};
                            response.data[0].Date = new Date();
                            $scope.UpdateDetails(response.data[0]);
                        });
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                })
            }

            $scope.UpdateDetails = function (data) {

                var SalesEnquiry = data;
                $scope.VoucherExtraTables = SalesEnquiry.VoucherExtraTables;
                $scope.VoucherDocs = data.VoucherDocs;

                //                if ($scope.VDesign.SkipVoucherLinkValidation == false) {
                //                    $scope.IsLinkedScreen = false;
                //                    if ($scope.SalesEnquiry.LinkedRefNos == null) {
                //                        $scope.IsLinkedScreen = false;
                //                    } else if ($scope.SalesEnquiry.LinkedRefNos.length > 0) {
                //                        $scope.IsLinkedScreen = true;
                //                    }
                //                }

                SalesEnquiry.Date = new Date(SalesEnquiry.Date);

                if (SalesEnquiry.SupplierBillDate != null) {
                    SalesEnquiry.SupplierBillDate = new Date(SalesEnquiry.SupplierBillDate);
                }
                if (SalesEnquiry.DeliveryDate != null) {
                    SalesEnquiry.DeliveryDate = new Date(SalesEnquiry.DeliveryDate);
                }
                if (SalesEnquiry.ReturnDate != null) {
                    SalesEnquiry.ReturnDate = new Date(SalesEnquiry.ReturnDate);
                }

                if (SalesEnquiry.Field16 != null) {
                    SalesEnquiry.Field16 = new Date(SalesEnquiry.Field16);
                }
                if (SalesEnquiry.Field17 != null) {
                    SalesEnquiry.Field17 = new Date(SalesEnquiry.Field17);
                }
                if (SalesEnquiry.Field18 != null) {
                    SalesEnquiry.Field18 = new Date(SalesEnquiry.Field18);
                }
                if (SalesEnquiry.Field19 != null) {
                    SalesEnquiry.Field19 = new Date(SalesEnquiry.Field19);
                }
                if (SalesEnquiry.Field20 != null) {
                    SalesEnquiry.Field20 = new Date(SalesEnquiry.Field20);
                }

                angular.forEach(data.PurchaseRequestCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })

                data.PurchaseEnquiryCosts = data.PurchaseRequestCosts;


                $scope.rowId = 0;
                angular.forEach(SalesEnquiry.PurchaseRequestDetails, function (e) {

                    if ($scope.VoucherSet.IsLoadProductUnitOnly) {
                        MainService.GetProductUnitsInDropdown(e.ProductId).then(function (response) {
                            if (response.data.length > 0) {
                                e.Units = response.data;
                            } else {
                                e.Units = $scope.Units;
                            }
                        })
                    } else {
                        e.Units = $scope.Units;
                    }

                    if (e.Field16 != null) {
                        e.Field16 = new Date(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.Field17 = new Date(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.Field18 = new Date(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.Field19 = new Date(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.Field20 = new Date(e.Field20);
                    }

                    var costs = angular.copy($scope.CostCenters);
                    if (e.PurchaseRequestCosts.length > 0) {
                        angular.forEach(e.PurchaseRequestCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }

                    e.PurchaseEnquiryCosts = e.PurchaseRequestCosts;

                    e.rowId = $scope.rowId++;

                });

                data.PurchaseEnquiryDetails = data.PurchaseRequestDetails;

                $scope.CalculateTotals(SalesEnquiry);
                $scope.PurchaseEnquiries.push(SalesEnquiry);
                $scope.EnquiryCopy = angular.copy(SalesEnquiry);

            }


            $scope.ContextInsertRow = function (temp) {
                $scope.InsertRow(temp);
                if ($scope.RearrangeReqired == true) {
                    $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                }
            }


            $scope.InsertRow = function (temp) {

                var isLinked = false;

                if (temp != 1) {
                    if ($scope.SalesEnquiry.LinkedRefNos == null) {
                        isLinked = false;
                    } else if ($scope.SalesEnquiry.LinkedRefNos.length > 0) {
                        isLinked = true;
                    }
                }

                if (isLinked && $scope.VDesign.SkipVoucherLinkValidation == false) {
                    toastr.info("Linked Vouchers, Operation Not Permitted");
                } else {

                    var PurchaseEnquiryDetails = {

                        PurchaseEnquiryDetails: [],
                        Id: 0,
                        Quantity: 1,
                        Total: 0,
                        UnitPrice: 0,
                        NetTotal: 0,
                        TaxValue: 0,
                        VatType: "Exclusive",
                        DiscountType: "Value",
                        DiscountValue: 0,
                        InventoryValue: 0,
                        TaxableAmount: 0,
                        RoundOfVat: 0,
                        Discount: 0,
                        OtherCharges: 0,
                        ExtraCharges: 0,
                        Remarks: "",
                        IntroLetterDescription: "",
                        EndLetterDescription: "",
                        ProductId: "",
                        CountryId: "",
                        WarehouseId: "",
                        BrandId: "",
                        VATId: "",
                        UnitId: "",
                        Product: {},
                        CostCenters: angular.copy($scope.CostCenters),
                        rowId: $scope.rowId++,
                        Field16: null,
                        Field17: null,
                        Field18: null,
                        Field19: null,
                        Field20: null,

                        Vat1Per: $scope.VDesign.DefaultVat1,
                        Vat2Per: $scope.VDesign.DefaultVat2,
                        Vat3Per: $scope.VDesign.DefaultVat3,
                        Vat4Per: $scope.VDesign.DefaultVat4,
                        Vat5Per: $scope.VDesign.DefaultVat5,
                        AssessableValue: 0,

                        Vat1Value: 0,
                        Vat2Value: 0,
                        Vat3Value: 0,
                        Vat4Value: 0,
                        Vat5Value: 0,
                        Units: $scope.Units,
                    }

                    if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                        PurchaseEnquiryDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                    }



                    if (temp != 100) {
                        $scope.SalesEnquiry.PurchaseEnquiryDetails.push(PurchaseEnquiryDetails);
                    } else {

                        var index = $scope.SalesEnquiry.PurchaseEnquiryDetails.indexOf($scope.ClickedRow);
                        $scope.SalesEnquiry.PurchaseEnquiryDetails.splice(index + 1, 0, PurchaseEnquiryDetails);
                    }

                }
            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];
                if ($scope.TableReorder != null && $scope.TableReorder != "") {
                    if ($scope.TableReorder.ColumnArray != null && $scope.TableReorder.ColumnArray != '' && $scope.TableReorder.ColumnArray != undefined) {
                        var arr = $scope.TableReorder.ColumnArray;
                        $scope.tableReorderColumnArray = JSON.parse(arr);
                        $scope.RearrangeReqired = true;
                        $scope.rearrangeTableCells($scope.tableReorderColumnArray);
                    }
                }

            };


            $scope.init = function () {

                $scope.PurchaseEnquiries = [];
                $scope.Customer = {};
                $scope.CustomerId = "";
                $scope.rowId = 0;
                $scope.expandView = false;
                $scope.IsAllowChangeQty = false;
                $scope.IsAllowAddProduct = false;

                $scope.IsVoucherLinkCost = false;
                $scope.VCCostcenterId = "";
                $scope.mvl = {
                    SelectAllMVlinks: false
                };
                $scope.Load = false;
                $scope.ErrorText = "";
                $scope.print = {
                    IsPrint: false,
                }
                $scope.ViewVal = 0;

                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);


                $scope.CompanyProfile = {};
                $scope.TableReorder = {};

                if ($stateParams.VoucherId > 0) {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.VoucherSettingsbyType("Purchase Enquiry").then(function (response) {
                        if (response.data) {

                            $scope.CompanyProfile = response.data.CompanyProfile;
                            $scope.CostCenters = response.data.CostCenterSettings;

                            $scope.VoucherSet = response.data.voucherAccount;

                            if ($scope.VoucherSet == null || $scope.VoucherSet == "") {
                                $scope.VoucherSet = {
                                    AllowZeroCost: false
                                };
                            }

                            $scope.VDesign = response.data.VoucherDesign;
                            $scope.TableReorder = response.data.TableReorder;
                            $scope.ReArrangeTable();
                            $scope.loadVoucher($stateParams.VoucherId);

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    })


                }

            }
            $scope.init();


            $scope.ChangeView = function (id) {
                $scope.ViewVal = id;
            }


            $scope.CustomerAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Purchase Enquiry";
                        MainService.LoadCustomerAccountsSPInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.CustomerAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Customer = {};
                    $scope.Customer = data;
                    $scope.CustomerId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.CustomerAutocompleteDataSource
            };

            $scope.updateBySupplierConfig = function () {
                if ($scope.AvailableSuppliers.length == 0) {
                    toastr.warning("Supplier Configurations Not Found");
                } else {
                    angular.forEach($scope.AvailableSuppliers, function (e) {
                        $scope.CustomerId = e.Id;
                        $scope.Customer = {
                            Id: e.Id,
                            Name: e.Name,
                            ProductIds: e.ProductIds
                        }
                        $scope.AddCustomer2();
                    })
                }
            }

            $scope.AddCustomer2 = function () {

                if ($scope.CustomerId > 0) {
                    var found = false;

                    angular.forEach($scope.PurchaseEnquiries, function (e) {
                        if ($scope.CustomerId == e.CustomerId) {
                            found = true;
                        }
                    })

                    if (found == true) {
                        toastr.warning("Supplier Already Added");
                    } else {
                        if (!$scope.PurchaseEnquiries[0].CustomerId > 0) {
                            $scope.PurchaseEnquiries[0].CustomerId = angular.copy($scope.CustomerId);
                            $scope.PurchaseEnquiries[0].Customer = angular.copy($scope.Customer);
                            var pdtArray = [];
                            angular.forEach($scope.PurchaseEnquiries[0].PurchaseEnquiryDetails, function (e) {
                                var temp = angular.copy(e);
                                if ($scope.Customer.ProductIds.includes(temp.ProductId)) {
                                    temp.CustomerId = angular.copy($scope.CustomerId);
                                    pdtArray.push(temp);
                                }
                            })
                            $scope.PurchaseEnquiries[0].PurchaseEnquiryDetails = angular.copy(pdtArray);
                            $scope.CalculateTotals($scope.PurchaseEnquiries[0]);
                            $scope.Customer = {};
                            $scope.CustomerId = "";

                        } else {
                            var pe = angular.copy($scope.EnquiryCopy);
                            pe.CustomerId = angular.copy($scope.CustomerId);
                            pe.Customer = angular.copy($scope.Customer);
                            var pdtArray = [];
                            angular.forEach(pe.PurchaseEnquiryDetails, function (e) {
                                var temp = angular.copy(e);
                                if ($scope.Customer.ProductIds.includes(temp.ProductId)) {
                                    temp.CustomerId = angular.copy($scope.CustomerId);
                                    pdtArray.push(temp);
                                }
                            })
                            pe.PurchaseEnquiryDetails = angular.copy(pdtArray);
                            $scope.CalculateTotals(pe);
                            $scope.PurchaseEnquiries.push(pe);
                            $scope.Customer = {};
                            $scope.CustomerId = "";
                        }
                    }
                }

            }

            $scope.AddCustomer = function () {

                if ($scope.CustomerId > 0) {
                    var found = false;

                    angular.forEach($scope.PurchaseEnquiries, function (e) {
                        if ($scope.CustomerId == e.CustomerId) {
                            found = true;
                        }
                    })

                    if (found == true) {
                        toastr.warning("Supplier Already Added");
                    } else {
                        if (!$scope.PurchaseEnquiries[0].CustomerId > 0) {
                            $scope.PurchaseEnquiries[0].CustomerId = angular.copy($scope.CustomerId);
                            $scope.PurchaseEnquiries[0].Customer = angular.copy($scope.Customer);
                            angular.forEach($scope.PurchaseEnquiries[0].PurchaseEnquiryDetails, function (e) {
                                e.CustomerId = angular.copy($scope.CustomerId);
                            })
                            $scope.Customer = {};
                            $scope.CustomerId = "";

                        } else {
                            var pe = angular.copy($scope.EnquiryCopy);
                            pe.CustomerId = angular.copy($scope.CustomerId);
                            pe.Customer = angular.copy($scope.Customer);
                            angular.forEach(pe.PurchaseEnquiryDetails, function (e) {
                                e.CustomerId = angular.copy($scope.CustomerId);
                            })
                            $scope.PurchaseEnquiries.push(pe);
                            $scope.Customer = {};
                            $scope.CustomerId = "";
                        }
                    }
                }

            }


            /////////////////////////////////Product//////////////

            $scope.productsMultiSearchDataSource = {
                type: "odata",
                serverFiltering: true,
                serverPaging: true,
                pageSize: 20,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {} else {
                                MainService.productInAutoComplete(o.data).then(function (response) {

                                    if ($scope.VoucherSet.DefauldUnitId > 0) {
                                        angular.forEach(response.data.Data, function (e) {
                                            e.UnitId = $scope.VoucherSet.DefauldUnitId;
                                            e.Unit = $scope.VoucherSet.DefauldUnit;
                                        })
                                    }

                                    var temp = {
                                        d: {
                                            "results": response.data.Data,
                                            "__count": response.data.Total
                                        }
                                    }
                                    o.success(temp);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error($scope.NetworkErrorLan);
                                });
                            }
                        } else {
                            var temp = {
                                d: {
                                    "results": [],
                                    "__count": 0
                                }
                            }
                            o.success(temp);
                        }
                    }
                }
            };


            $scope.ProductMultiSearchOptions = {
                placeholder: "",
                dataTextField: "Name",
                dataValueField: "Name",
                filter: "contains",
                autoBind: false,
                minLength: 3,
                enforceMinLength: true,
                dropDownWidth: 700,
                height: 300,
                dataSource: $scope.productsMultiSearchDataSource,
                columns: [
                    {
                        field: "Name",
                        title: "Name",
                        width: "250px"
                    },
                    {
                        field: "ProductCode",
                        title: "Code",
                        width: "100px"
                    },
                    {
                        field: "CategoryName",
                        title: "Category",
                    },
                    {
                        field: "BrandName",
                        title: "Brand",
                    },
                    {
                        field: "CountryName",
                        title: "Country",
                    },
                    {
                        field: "HSCode",
                        title: "HS_Code",
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                    },
                    {
                        field: "Weight",
                        title: "Weight",
                    },

                ],

            };

            $scope.ProductCodeMultiSearchOptions = {
                placeholder: "",
                dataTextField: "ProductCode",
                dataValueField: "ProductCode",
                filter: "contains",
                autoBind: false,
                minLength: 3,
                enforceMinLength: true,
                dropDownWidth: 700,
                height: 300,
                dataSource: $scope.productsMultiSearchDataSource,
                columns: [
                    {
                        field: "ProductCode",
                        title: "Code",
                        width: "100px"
                    },
                    {
                        field: "Name",
                        title: "Name",
                        width: "250px"
                    },
                    {
                        field: "CategoryName",
                        title: "Category",
                    },
                    {
                        field: "BrandName",
                        title: "Brand",
                    },
                    {
                        field: "CountryName",
                        title: "Country",
                    },
                    {
                        field: "HSCode",
                        title: "HS_Code",
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                    },
                    {
                        field: "Weight",
                        title: "Weight",
                    },

                ],

            };



            $scope.applyFocus = function (data) {
                $scope.SelectedCE = data;
            }

            $scope.click2 = function (data, product) {

                var comboBox = $("#kendoProduct" + data.rowId).data("kendoMultiColumnComboBox");
                var product = comboBox.dataItem(); // Get selected item directly
                console.log('onChange selected:', product); // Optional: Log for verification

                if (product != undefined) {
                    data.Product = {};
                    data.Product.Name = product.Name;
                    data.Remarks = product.Description;
                    data.Product.ProductCode = product.ProductCode;
                    data.Product.Balance = product.Balance;
                    data.Product.AveragePrice = product.AveragePrice;
                    data.ProductId = product.Id;
                    data.UnitId = product.UnitId;
                    data.UnitPrice = product.PurchasePrice;
                    data.CountryId = product.CountryId;
                    data.BrandId = product.BrandId;
                    data.VATId = product.VATId;
                    data.UnitPrice = product.PurchasePrice;
                    data.Cost = product.AveragePrice;
                    data.COGS = product.AveragePrice;
                    data.NetWeight = product.Weight;
                    data.GrossWeight = product.GrossWeight;
                    data.VatType = product.VatType;

                    $scope.click($scope.SalesEnquiry.PurchaseEnquiryDetails[data.rowId], 0);
                    $scope.LoadFromChart(3);
                }
            }

            $scope.click3 = function (data, product) {

                var comboBox = $("#kendoProductCode" + data.rowId).data("kendoMultiColumnComboBox");
                var product = comboBox.dataItem(); // Get selected item directly
                console.log('onChange selected:', product); // Optional: Log for verification

                if (product != undefined) {
                    data.Product = {};
                    data.Product.Name = product.Name;
                    data.Remarks = product.Description;
                    data.Product.ProductCode = product.ProductCode;
                    data.Product.Balance = product.Balance;
                    data.Product.AveragePrice = product.AveragePrice;
                    data.ProductId = product.Id;
                    data.UnitId = product.UnitId;
                    data.UnitPrice = product.PurchasePrice;
                    data.CountryId = product.CountryId;
                    data.BrandId = product.BrandId;
                    data.VATId = product.VATId;
                    data.UnitPrice = product.PurchasePrice;
                    data.Cost = product.AveragePrice;
                    data.COGS = product.AveragePrice;
                    data.NetWeight = product.Weight;
                    data.GrossWeight = product.GrossWeight;
                    data.VatType = product.VatType;

                    $scope.click($scope.SalesEnquiry.PurchaseEnquiryDetails[data.rowId], 0);
                    $scope.LoadFromChart(3);
                }
            }

            $scope.click = function (data, temp) {

                var SelectedEnquiry = {};
                angular.forEach($scope.PurchaseEnquiries, function (e) {
                    if (data.CustomerId == e.CustomerId) {
                        SelectedEnquiry = e;
                    }
                })

                $scope.SelectedCE = data;

                if ($scope.VoucherSet.IsLoadProductUnitOnly && $scope.SelectedCE.ProductId > 0) {
                    MainService.GetProductUnitsInDropdown($scope.SelectedCE.ProductId).then(function (response) {
                        if (response.data.length > 0) {
                            data.Units = response.data;
                        } else {
                            data.Units = $scope.Units;
                        }
                    })
                } else {
                    data.Units = $scope.Units;
                }

                $scope.SelectedCE.TotalNetWeight = $scope.SelectedCE.Quantity * $scope.SelectedCE.NetWeight;
                $scope.SelectedCE.TotalGrossWeight = $scope.SelectedCE.Quantity * $scope.SelectedCE.GrossWeight;

                if ($scope.VDesign.IsShippingFormula) {
                    var v1 = parseFloat(data.Field1);
                    var v2 = parseFloat(data.Field2);
                    var v3 = parseFloat(data.Field3);
                    var vt = (v1 * v2 * v3 * data.Quantity) / 1.62;
                    vt = Math.round(vt * 100) / 100;
                    data.Field6 = vt.toString();
                }

                data.Total = data.Quantity * data.UnitPrice;
                data.Total = Math.round(data.Total * 100) / 100;

                data.taxval = 0;
                angular.forEach($scope.VATs, function (e) {
                    if (e.Id == data.VATId) {
                        data.taxval = e.Value;
                    }
                });

                if ($scope.VDesign.UnlockDiscount == false) {
                    if (data.DiscountType == "Value") {
                        data.Discount = data.DiscountValue;
                    } else {
                        var disc = data.Total * (data.DiscountValue / 100);
                        data.Discount = Math.round(disc * 100) / 100;
                    }
                }

                if (data.VatType != "Exclusive") {

                    data.TaxValue = ((data.Total - data.Discount + data.OtherCharges) * data.taxval) / (100 + data.taxval);
                    data.TaxValue = Math.round(data.TaxValue * 100) / 100;
                    data.TaxableAmount = data.Total - data.Discount + data.OtherCharges;
                    data.TaxableAmount = data.TaxableAmount - data.TaxValue;
                    data.TaxableAmount = Math.round(data.TaxableAmount * 100) / 100;

                } else {

                    data.TaxableAmount = data.Total - data.Discount + data.OtherCharges;
                    data.TaxableAmount = Math.round(data.TaxableAmount * 100) / 100;
                    data.TaxValue = data.TaxableAmount * (data.taxval / 100);
                    data.TaxValue = Math.round(data.TaxValue * 100) / 100;

                }

                if ($scope.VoucherSet.IsReverseVAT) {
                    var totalLevi = 0;
                    if (data.Vat1Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat1;
                    }
                    if (data.Vat2Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat2;
                    }
                    if (data.Vat3Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat3;
                    }
                    if (data.Vat4Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat4;
                    }
                    if (data.Vat5Per > 0) {
                        totalLevi = totalLevi + $scope.VDesign.DefaultVat5;
                    }


                    if (totalLevi > 0) {

                        var leviesFraction = (totalLevi / (totalLevi + 100)) * data.TaxableAmount;
                        data.AssessableValue = data.TaxableAmount - leviesFraction;
                        data.AssessableValue = Math.round(data.AssessableValue * 100) / 100;

                        if (data.Vat1Per > 0) {

                            data.Vat1Value = data.AssessableValue * (data.Vat1Per / 100);
                            data.Vat1Value = Math.round(data.Vat1Value * 100) / 100;

                            //                            data.Vat1Value = (data.AssessableValue * data.Vat1Per) / (100 + data.Vat1Per);
                            //                            data.Vat1Value = Math.round(data.Vat1Value * 100) / 100;
                        }

                        if (data.Vat2Per > 0) {

                            data.Vat2Value = data.AssessableValue * (data.Vat2Per / 100);
                            data.Vat2Value = Math.round(data.Vat2Value * 100) / 100;

                            //                            data.Vat2Value = (data.AssessableValue * data.Vat2Per) / (100 + data.Vat2Per);
                            //                            data.Vat2Value = Math.round(data.Vat2Value * 100) / 100;
                        }

                        if (data.Vat3Per > 0) {

                            data.Vat3Value = data.AssessableValue * (data.Vat3Per / 100);
                            data.Vat3Value = Math.round(data.Vat3Value * 100) / 100;

                            //                            data.Vat3Value = (data.AssessableValue * data.Vat3Per) / (100 + data.Vat3Per);
                            //                            data.Vat3Value = Math.round(data.Vat3Value * 100) / 100;
                        }

                        if (data.Vat4Per > 0) {

                            data.Vat4Value = data.AssessableValue * (data.Vat4Per / 100);
                            data.Vat4Value = Math.round(data.Vat4Value * 100) / 100;

                            //                            data.Vat4Value = (data.AssessableValue * data.Vat4Per) / (100 + data.Vat4Per);
                            //                            data.Vat4Value = Math.round(data.Vat4Value * 100) / 100;
                        }

                        if (data.Vat5Per > 0) {

                            data.Vat5Value = data.AssessableValue * (data.Vat5Per / 100);
                            data.Vat5Value = Math.round(data.Vat5Value * 100) / 100;

                            //                            data.Vat5Value = (data.AssessableValue * data.Vat5Per) / (100 + data.Vat5Per);
                            //                            data.Vat5Value = Math.round(data.Vat5Value * 100) / 100;
                        }


                    }

                }


                if (temp != 50) {
                    data.RoundOfVat = data.TaxValue;
                }

                data.InventoryValue = data.TaxableAmount + data.RoundOfVat + data.ExtraCharges;
                data.InventoryValue = Math.round(data.InventoryValue * 100) / 100;

                $scope.CalculateTotals(SelectedEnquiry);

            }


            $scope.CalculateTotals = function (SalesEnquiry) {

                SalesEnquiry.TotalQuantity = 0;
                SalesEnquiry.TotalDiscount = 0;
                SalesEnquiry.GrossTotal = 0;
                SalesEnquiry.NetTotal = 0;
                SalesEnquiry.TotalTax = 0;
                SalesEnquiry.GrandTotal = 0;
                SalesEnquiry.TotalExtraCharges = 0;
                SalesEnquiry.TotalOtherCharges = 0;


                angular.forEach(SalesEnquiry.PurchaseEnquiryDetails, function (e) {

                    if (e.ProductId > 0) {

                        SalesEnquiry.TotalQuantity = SalesEnquiry.TotalQuantity + e.Quantity;

                        SalesEnquiry.TotalDiscount = SalesEnquiry.TotalDiscount + e.Discount;
                        SalesEnquiry.TotalDiscount = Math.round(SalesEnquiry.TotalDiscount * 100) / 100;

                        SalesEnquiry.GrossTotal = SalesEnquiry.GrossTotal + e.Total;
                        SalesEnquiry.GrossTotal = Math.round(SalesEnquiry.GrossTotal * 100) / 100;

                        SalesEnquiry.NetTotal = SalesEnquiry.NetTotal + e.TaxableAmount;
                        SalesEnquiry.NetTotal = Math.round(SalesEnquiry.NetTotal * 100) / 100;

                        SalesEnquiry.TotalTax = SalesEnquiry.TotalTax + e.RoundOfVat;
                        SalesEnquiry.TotalTax = Math.round(SalesEnquiry.TotalTax * 100) / 100;

                        SalesEnquiry.GrandTotal = SalesEnquiry.GrandTotal + e.InventoryValue;
                        SalesEnquiry.GrandTotal = Math.round(SalesEnquiry.GrandTotal * 100) / 100;

                        SalesEnquiry.TotalExtraCharges = SalesEnquiry.TotalExtraCharges + e.ExtraCharges;
                        SalesEnquiry.TotalExtraCharges = Math.round(SalesEnquiry.TotalExtraCharges * 100) / 100;

                        SalesEnquiry.TotalOtherCharges = SalesEnquiry.TotalOtherCharges + e.OtherCharges;
                        SalesEnquiry.TotalOtherCharges = Math.round(SalesEnquiry.TotalOtherCharges * 100) / 100;

                    }

                });

                if (SalesEnquiry.AddDiscountPer > 0 && $scope.VDesign.IsUnlockAdditionalDiscount == false) {

                    var disc = SalesEnquiry.GrandTotal * (SalesEnquiry.AddDiscountPer / 100);
                    SalesEnquiry.AddDiscount = Math.round(disc * 100) / 100;
                }

                if ($scope.VDesign.IsUnlockAdditionalDiscount) {

                    SalesEnquiry.AddDiscountPer = (SalesEnquiry.AddDiscount / SalesEnquiry.GrandTotal) * 100;
                    SalesEnquiry.AddDiscountPer = Math.round(SalesEnquiry.AddDiscountPer * 100) / 100;
                }

                if (SalesEnquiry.AddDiscount > 0) {
                    SalesEnquiry.TotalDiscount = SalesEnquiry.TotalDiscount + SalesEnquiry.AddDiscount;
                    SalesEnquiry.TotalDiscount = Math.round(SalesEnquiry.TotalDiscount * 100) / 100;

                    SalesEnquiry.GrandTotal = SalesEnquiry.GrandTotal - SalesEnquiry.AddDiscount;
                    SalesEnquiry.GrandTotal = Math.round(SalesEnquiry.GrandTotal * 100) / 100;
                }



            }


            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                angular.forEach($scope.PurchaseEnquiries, function (SalesEnquiry) {
                    SalesEnquiry.DateString = $scope.extractDate(SalesEnquiry.Date);
                    if (SalesEnquiry.DeliveryDate != null) {
                        SalesEnquiry.DelDateString = $scope.extractDate(SalesEnquiry.DeliveryDate);
                    }
                    if (SalesEnquiry.ReturnDate != null) {
                        SalesEnquiry.RetDateString = $scope.extractDate(SalesEnquiry.ReturnDate);
                    }
                    if (SalesEnquiry.SupplierBillDate != null) {
                        SalesEnquiry.SupDateString = $scope.extractDate(SalesEnquiry.SupplierBillDate);
                    }
                    if (SalesEnquiry.Field16 != null) {
                        SalesEnquiry.F16DateString = $scope.extractDate(SalesEnquiry.Field16);
                    }
                    if (SalesEnquiry.Field17 != null) {
                        SalesEnquiry.F17DateString = $scope.extractDate(SalesEnquiry.Field17);
                    }
                    if (SalesEnquiry.Field18 != null) {
                        SalesEnquiry.F18DateString = $scope.extractDate(SalesEnquiry.Field18);
                    }
                    if (SalesEnquiry.Field19 != null) {
                        SalesEnquiry.F19DateString = $scope.extractDate(SalesEnquiry.Field19);
                    }
                    if (SalesEnquiry.Field20 != null) {
                        SalesEnquiry.F20DateString = $scope.extractDate(SalesEnquiry.Field20);
                    }

                    $scope.ErrorText = "";

                    var count = 0;
                    var count2 = 0;
                    angular.forEach(SalesEnquiry.PurchaseEnquiryDetails, function (e) {

                        if (e.Field16 != null) {
                            e.F16DateString = $scope.extractDate(e.Field16);
                        }
                        if (e.Field17 != null) {
                            e.F17DateString = $scope.extractDate(e.Field17);
                        }
                        if (e.Field18 != null) {
                            e.F18DateString = $scope.extractDate(e.Field18);
                        }
                        if (e.Field19 != null) {
                            e.F19DateString = $scope.extractDate(e.Field19);
                        }
                        if (e.Field20 != null) {
                            e.F20DateString = $scope.extractDate(e.Field20);
                        }

                        if (!$scope.VoucherSet.AllowZeroCost) {
                            if (e.ProductId > 0 && e.Total <= 0) {
                                count = count + 1;
                            }
                            if (e.ProductId == "" && e.Total > 0) {
                                count = count + 1;
                            }
                        }

                        if (e.ProductId == "" && e.Total == 0) {
                            count2 = count2 + 1;
                        }

                        if (e.ProductId > 0) {
                            e.PurchaseEnquiryCosts = [];
                            angular.forEach(e.CostCenters, function (a) {
                                if (a.Section == "Body") {
                                    if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                        $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                    } else {
                                        if (a.SelectedCostCenterId > 0) {
                                            var cst = {
                                                CostCenterId: a.SelectedCostCenterId,
                                            }
                                            e.PurchaseEnquiryCosts.push(cst);
                                            console.log(e);
                                        }
                                    }
                                }
                            })
                        }



                    });

                    SalesEnquiry.PurchaseEnquiryCosts = [];
                    angular.forEach($scope.CostCenters, function (e) {
                        if (e.Section == "Head") {
                            if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                            } else {
                                if (e.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: e.SelectedCostCenterId,
                                    }
                                    SalesEnquiry.PurchaseEnquiryCosts.push(cst);
                                }
                            }
                        }
                    })

                    if ($scope.VoucherSet.IsSaveWithLinking == true && !$scope.IsLinkedScreen && !SalesEnquiry.Id > 0) {
                        $scope.ErrorText = "Linking Not Found. Please Link Voucher.";
                    }

                    if (!SalesEnquiry.VoucherNumber.length > 0) {
                        $scope.ErrorText = "Please Enter Voucher No.";
                    }

                    if ($scope.VDesign != null) {
                        if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                            $scope.ErrorText = "Attachment Missing";
                        }
                    }

                    if (SalesEnquiry.CustomerId == "" && SalesEnquiry.Customer == undefined) {
                        $scope.ErrorText = "Please Select/ Enter Supplier ";
                    } else if (count > 0) {
                        $scope.ErrorText = "Invalid Details";
                    }
                })

                if ($scope.ErrorText == "") {
                    $('#saveModal').modal('show');
                } else {
                    toastr.warning($scope.ErrorText);
                }

            }

            $scope.SaveWithConfirm = function () {
                var tt = 1;
                var ttt = 0;
                $scope.processPESave(tt, ttt);
            }


            $scope.processPESave = function (tt, ttt) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var VoucherData = angular.copy($scope.PurchaseEnquiries[ttt]);
                angular.forEach(VoucherData.PurchaseEnquiryDetails, function (e) {
                    e.CostCenters = [];
                })
                VoucherData.VoucherExtraTables = $scope.VoucherExtraTables;
                VoucherData.VoucherDocs = $scope.VoucherDocs;

                MainService.AddPurchaseEnquiry(VoucherData).then(function (response) {
                    if (response.data.Message == "Success") {

                        if ($scope.PurchaseEnquiries.length == tt) {
                            $scope.Load = false;
                            toastr.success("Success");
                            $('#saveModal').modal('hide');
                            setTimeout(function () {
                                $state.go("PurchaseEnquiry");
                            }, 1000)
                        } else {
                            tt = tt + 1;
                            ttt = ttt + 1;
                            $scope.processPESave(tt, ttt);
                        }

                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data.Message);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

            }


            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data, pe) {
                $scope.ClickedRow = data;
                $scope.ClickedEnquiry = pe;
            }

            $scope.deleteRow = function () {

                var index = $scope.ClickedEnquiry.PurchaseEnquiryDetails.indexOf($scope.ClickedRow);
                $scope.ClickedEnquiry.PurchaseEnquiryDetails.splice(index, 1);

                $scope.CalculateTotals($scope.ClickedEnquiry);

            }


            $scope.RemoveEnquiry = function (data) {

                var index = $scope.PurchaseEnquiries.indexOf(data);
                $scope.PurchaseEnquiries.splice(index, 1);

            }




        }])
